import React from "react"

import {Deal, UserSaving} from "@irati/types"
import DealSavingsTypes from "@irati/deals/types/enums/DealSavingsType"
import {H2, Label} from "@irati/ui/src/Typography"
import FormattedMessage, {FormattedCurrency} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import getDealCurrency from "@irati/deals/helpers/deals/currency"

import {OldValueLabel, SavingHeader} from "./styled"

type Props = {
  deal: Deal
}

const PromoSection = ({deal}: Props) => {
  const {savings} = deal
  const currency = getDealCurrency(deal)
  const {userSavings, boostedSavings} = savings as Required<UserSaving>
  const oldSavingVal = boostedSavings?.oldSavings?.value
  const isCurrencySaving = userSavings?.type === DealSavingsTypes.CURRENCY

  switch (userSavings?.type) {
    case DealSavingsTypes.SPECIAL_RATES:
      return (
        <H2>
          <FormattedMessage id="perks.components.saving.specialRates" />
        </H2>
      )

    case DealSavingsTypes.FREE:
      return (
        <H2>
          <FormattedMessage id="perks.saving.free" />
        </H2>
      )
  }

  return (
    <div>
      <Label color="contrast" display="block" textAlign="right" marginBottom={0.5}>
        {userSavings.header}
      </Label>
      <Flex alignItems="center">
        <SavingHeader marginRight={2}>
          {userSavings.type === DealSavingsTypes.PERCENTAGE ? (
            `${userSavings.value}%`
          ) : (
            <FormattedCurrency isCents={false} value={userSavings.value} currency={currency} />
          )}
        </SavingHeader>
        {oldSavingVal && (
          <OldValueLabel large textDecoration="line-through">
            {isCurrencySaving ? <FormattedCurrency value={oldSavingVal} currency={currency} isCents={false} /> : `${oldSavingVal}%`}
          </OldValueLabel>
        )}
      </Flex>
    </div>
  )
}

export default PromoSection
